import { getUrlOrHashParam } from "../helpers/urlParams";

const debugKey = "yleplayerdebug";

export const isDebugEnabled = type =>
  !!getUrlOrHashParam(window, debugKey)?.includes(type) ||
  !!localStorage.getItem(debugKey)?.includes(type);
